import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';
import { LIST_GALLERY } from '../../../apiCalls/urls/gallery';
import { GET_LIST } from '../../../apiCalls/urls/common';
export const galleryApi = createApi({
    baseQuery,
    tagTypes: ['gallery'],
    reducerPath: 'galleryApi',
    endpoints: (builder) => ({
        getGalleryList: builder.query({
            query: (bodyData) => ({
                url: LIST_GALLERY,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['gallery'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetGalleryListQuery,
    useGetListMutation
} = galleryApi;